<template>
  <div id="weather">
    <div v-if="!error" id="display">
      <div id="top">
        <div class="location">{{ location }}</div>
        <div class="time">{{ testimonyTime | prettyDate }}</div>
        <div class="status">{{ summary }}</div>
      </div>

      <div id="left-information">
        <img :src="getThumbnail(status, 64)" :alt="status" class="thumbnail" />
        <div class="temperature">{{ temperature }}</div>
        <div class="unit">°C</div>
      </div>

      <div id="right-information">
        <span>Humidity: {{ humidity }}%</span><br/>     
        <span>Pressure: {{ pressure }} mb</span><br/>
        <span>Wind speed: {{ wind }} km/h</span>
      </div>

      <div id="forecast">

      </div>
    </div>

    <div v-else="">Location ID error</div>
  </div>
</template>

<script>
  import weather from '../../weather'
  import moment from 'moment'

  export default {
    props: ['longitude', 'latitude', 'testimonyTime'],
    data () {
      return {
        woeid: '1947122',
        location: '',
        summary: '',
        status: '',
        time: '',
        temperature: '0',
        humidity: '0',
        wind: '0',
        pressure: '0',
        forecast: [],
        error: true
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.changeLocation()
      })
    },
    methods: {
      changeLocation () {
        // Call API by Axios https://github.com/mzabriskie/axios
        weather.get(this.latitude, this.longitude, moment(this.testimonyTime).format('X'))
          .then((response) => {
            const data = response.data.currently
            if (data) {
              this.time = moment.unix(data.time)
              this.status = data.icon
              this.temperature = Math.round((data.temperature - 32) * (5 / 9) * 10) / 10 // °F to °C
              this.humidity = data.humidity
              this.pressure = data.pressure
              this.wind = Math.round((data.windSpeed * 1.609344 * 10)) / 10 // mph to kph
              this.summary = data.summary
              this.error = false
            }
          })
          .catch((error) => {
            console.log(error)
            if (error) {
              self.error = true
            }
          })
      },
      getThumbnail (status, size) {
        const cdn = `https://ssl.gstatic.com/onebox/weather`
        switch (status.toLowerCase()) {
          case 'hot':
            return `${cdn}/${size}/hot.png`
          case 'clear-day':
          case 'clear-night':
            return `${cdn}/${size}/sunny.png`
          case 'thunderstorms':
          case 'severe thunderstorms':
            return `${cdn}/${size}/thunderstorms.png`
          case 'scattered thunderstorms':
            return `${cdn}/${size}/rain_s_cloudy.png`
          case 'partly-cloudy-day':
          case 'mostly cloudy':
            return `${cdn}/${size}/partly_cloudy.png`
          case 'cloudy':
          case 'fog':
            return `${cdn}/${size}/cloudy.png`
          case 'showers':
          case 'scattered showers':
            return `${cdn}/${size}/rain_light.png`
          case 'rain':
            return `${cdn}/${size}/rain.png`
          case 'snow':
          case 'heavy snow':
          case 'snow flurries':
          case 'blowing snow':
            return `${cdn}/${size}/snow.png`
          case 'sleet':
            return `${cdn}/${size}/sleet.png`
          case 'wind':
            return `${cdn}/${size}/windy.png`
          default:
            return `${cdn}/${size}/cloudy.png`
        }
      }
    }
  }
</script>

<style>


#weather {
  margin: auto;
  max-width: 632px;
}

#display {
  padding: 20px 16px 24px 16px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
}

#top {
  margin-bottom: 20px;
}

#top .location {
  font-size: 24px;
  line-height: 1.2;
}

#top .time {
  font-size: 16px;
  line-height: 2;
}

#top .status {
  font-size: 13px;
  line-height: 1.4;
}

#left-information {
  color: #212121;
}

#left-information .thumbnail {
  float: left;
  height: 64px;
  width: 64px;
}

#left-information .temperature {
  float: left;
  margin-top: -3px;
  padding-left: 10px;
  font-size: 64px;
}

#left-information .unit {
  float: left;
  margin-top: 6px;
  font-size: 20px;
}

#right-information {
  float: right;
  padding-left: 5px;
  line-height: 22px;
  padding-top: 2px;
  min-width: 43%;
  font-weight: lighter;
}

#forecast {
  padding-top: 10px;
  clear: both;
}

#forecast ul {
  padding: 0;
  margin: 15px 0 5px 0;
}

#forecast ul li {
  display: inline-block;
  height: 90px;
  width: 73px;
  text-align: center;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// WeatherCard.vue?025c851f